const ChainId = {
  MAINNET: 1,
  POLYGON: 137,
  MUMBAI: 80001,
  TORONTO: 647,
  SXN: 416,
};

export const ADDRESSES = {
  [ChainId.TORONTO]: {
    WSX: "0x2D4e10Ee64CCF407C7F765B363348f7F62D2E06e",
    WETH: "0x93964E8d07585672b4d38E5F88E674fF2C418B02",
    WMATIC: "0x8e3Daba8F5EaE7c1034EdD6257B6EfA04d8b17E8",
    DAI: "0xC158aDf6e1dbbb4A89B646dfED62fCbfA18971B2",
    USDC: "0x5147891461a7C81075950f8eE6384e019e39ab98",
    IMX: "0x2aeddDeAd7AD7D7e2b1BE93F25ACb8d60975e11d",
    FACTORY: "0x24e6CE9f536990fbAf25D2B1d2eB70623B03F469",
    ROUTER: "0x4527Cdfaebc7DA96a5b4fEaa6c4E513Bd6186D02",
    SHARK: "0x5846A00372C5fA57AaE2B6dBfC5439A8FbfBA596", // Sushi
    MAKER: "0x16cFf572C0220AbE28cd51847186F0Ef42c5E3D9", // SushiMaker
    MINICHEF: "0x7c38FC39a5035Be9e2e03798c8CD5DFc94D1E54C",
    MULTICALL: "0x49F46F5A3f83D2dddcb7c9170ee2e7D49Ce62F34",
    TREASURY: "0x8f495cBC687396DEB6137fFb9CC4119E8591DEFB",
    GREENT: "0x9a20bBeff5Aa8701aBE34e04e020Da3F6a17da58", // GreenTest (Greenhouse Partner)
    SHARK_DESTINATION: "0xFf6dfFD5D1B834082B27DB43C4BB8D8023a565dc",
    ARBITRAGE: "0x01a61908c3fB382a18Abd8B252c46932669176c8"
  },
  [ChainId.MUMBAI]: {
    WETH: "0xA6FA4fB5f76172d178d61B04b0ecd319C5d1C0aa",
    WMATIC: "0x9c3c9283d3e44854697cd22d3faa240cfb032889",
    USDC: "0xa25dA0331Cd053FD17C47c8c34BCCBAaF516C438",
    DAI: "0xaff77c74e2a3861225173c2325314842338b73e6",
    SX: "0xDEA6BC85D436Ce75026916dffa9dc14325C87B5F",
    GREENT: "0xeCcf62fE96841530cb9c3ff2B0026630b6Bab58f" // GreenTest (Greenhouse Partner)
  },
  [ChainId.SXN]: {
    WSX: "0xaa99bE3356a11eE92c3f099BD7a038399633566f",
    WETH: "0xA173954Cc4b1810C0dBdb007522ADbC182DaB380",
    USDC: "0xe2aa35C2039Bd0Ff196A6Ef99523CC0D3972ae3e",
    GREEN: "0x50Fe32C331DAB714F8f2b3310A79B9eCCc1e5f5E", // Greenhouse
    WMATIC: "0xfa6F64DFbad14e6883321C2f756f5B22fF658f9C",
    DAI: "0x53813CD4aCD7145A716B4686b195511FA93e4Cb7",
    LFI: "0x4C882ec256823eE773B25b414d36F92ef58a7c0C",
    XBP: "0x7F251FBdB17Ae50fbc24d5e712e6cd1288C4Cec3",
    AX: "0xd9Fd6e207a2196e1C3FEd919fCFE91482f705909",
    FACTORY: "0x5Da4BEe3E6B545e9E28a7A303168A51eBd14C2Cf",
    ROUTER: "0x4de4d788d2AeFdf395c1766544F7092154E61ad2",
    SHARK: "0x7Dc31a2FCBfbAd1ed4519111Fd33f78316BcBC81", // Sushi
    MAKER: "0x2e39f32e5a3B7556C5FE3A456f862bA0aC5a46Ae", // SushiMaker
    MINICHEF: "0x7Cb0E2e944069D6d70A6f470154C4EEF3eB67530",
    MULTICALL: "0x5e4730Eb8f992187607CE6bA524d1f599dC2b2fe",
    TREASURY: "0xA168ad795Dfc792346d4e78Bf254E1572dea5454",
    SHARK_DESTINATION: "0x32C68DcFB218Fb7956b8636C039cD37a8E16CCb2",
    ARBITRAGE: "0x4FF29ba316AC3Af2aA13D56e3c9A29B5CB750CdC"
  },
  [ChainId.POLYGON]: {
    SX: "0x840195888Db4D6A99ED9F73FcD3B225Bb3cB1A79",
    WETH: "0x7ceB23fD6bC0adD59E62ac25578270cFf1b9f619",
    USDC: "0x2791Bca1f2de4661ED88A30C99A7a9449Aa84174",
    GREEN: "0x40DB6d7812b8288eCA452F912ca9F262b186f278", // Greenhouse
    WMATIC: "0x0d500b1d8e8ef31e21c99d1db9a6444d3adf1270",
    DAI: "0x8f3Cf7ad23Cd3CaDbD9735AFf958023239c6A063"
  },
};

export const SX_NETWORK_BRIDGE = {
  [ChainId.TORONTO]: {
    BRIDGE: "0x10837bb8D7C3e017893e8F73C765914F6d16421B",
    ERC20_HANDLER: "0xF7756997a65b807aDD0231F2e50fe0C272499cb1",
  },
  [ChainId.MUMBAI]: {
    BRIDGE: "0xAd05066217D013BA036a55C47372AfCba1934B1D",
    ERC20_HANDLER: "0xe6fE3b17f9961E4BE05A3D2770df8EDcC1836E8C",
  },
  [ChainId.SXN]: {
    BRIDGE: "0x8cC5E039Da0D8f2b61D933A3739ec5D92F878687",
    ERC20_HANDLER: "0x81B974a72715568f1426b90f01404c49866d6cDc",
  },
  [ChainId.POLYGON]: {
    BRIDGE: "0xE2d7B14aB17D8053de962bcAF9C5b273D41d44b3",
    ERC20_HANDLER: "0x41E8845d5a198c15d758A527aA69E90A635A3d0d",
  },
};

export const START_BLOCK = {
  [ChainId.TORONTO]: 727500,
  [ChainId.SXN]: 47000,
};

export const GRAPH_NODE = {
  [ChainId.TORONTO]: {
    URL: "https://graph.toronto.sx.technology/",
    IPFS: "http://52.6.102.161:5001"
  },
  [ChainId.SXN]: {
    URL: "https://graph.sx.technology",
    IPFS: "https://ipfs.sx.technology",
  },
}
